export const ru = {
    balance_invoice: 'Пополнение счета',
    can_download: 'Вы можете скачать счет и оплатить его.',
    amount: 'Сумма пополнения',
    download: 'Скачать счет',
};
